import axios from '@/api/$axios'

export default {
  list () {
    return axios.get(`/applets`)
  },
  detail (id) {
    return axios.get(`/applets/${id}`)
  },
  accesstoken (id) {
    return axios.get(`/applets/${id}/access_token`)
  }
}
